var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
export var grid = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: grid;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (p) { return p.gridTemplateColumns && "grid-template-columns: " + p.gridTemplateColumns + ";"; }, function (p) { return p.gridTemplateRows && "grid-template-rows: " + p.gridTemplateRows + ";"; }, function (p) { return p.gridColumn && "grid-column: " + p.gridColumn + ";"; }, function (p) { return p.gap && "gap: " + p.gap + ";"; });
export var getGridProps = function (_a) {
    var gridTemplateColumns = _a.gridTemplateColumns, gridTemplateRows = _a.gridTemplateRows, gridColumn = _a.gridColumn, gap = _a.gap;
    return ({
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows,
        gridColumn: gridColumn,
        gap: gap,
    });
};
export var Grid = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), grid);
var templateObject_1, templateObject_2;
